/**
 * Formata uma data do Firestore para string legível
 * @param date - Data do Firestore (Timestamp, Date, string ou objeto com _seconds e _nanoseconds)
 * @returns String formatada da data
 */
export const formatFirestoreDate = (date: any): string => {
  if (!date) return 'N/A';

  try {
    let dateObj: Date;

    // Handle Firestore Timestamp (tem método toDate)
    if (date.toDate && typeof date.toDate === 'function') {
      dateObj = date.toDate();
    }
    // Handle objeto com _seconds e _nanoseconds
    else if (date._seconds && date._nanoseconds) {
      dateObj = new Date(date._seconds * 1000 + date._nanoseconds / 1000000);
    }
    // Handle string dates
    else if (typeof date === 'string') {
      dateObj = new Date(date);
    }
    // Handle Date objects
    else if (date instanceof Date) {
      dateObj = date;
    }
    // Handle timestamp em segundos
    else if (typeof date === 'number') {
      dateObj = new Date(date * 1000);
    } else {
      return 'N/A';
    }

    // Verificar se a data é válida
    if (isNaN(dateObj.getTime())) {
      return 'N/A';
    }

    return dateObj.toLocaleString('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (error) {
    console.error('Error formatting date:', error, date);
    return 'N/A';
  }
};

/**
 * Formata uma data do Firestore apenas para data (sem hora)
 * @param date - Data do Firestore
 * @returns String formatada da data
 */
export const formatFirestoreDateOnly = (date: any): string => {
  if (!date) return 'N/A';

  try {
    let dateObj: Date;

    // Handle Firestore Timestamp (tem método toDate)
    if (date.toDate && typeof date.toDate === 'function') {
      dateObj = date.toDate();
    }
    // Handle objeto com _seconds e _nanoseconds
    else if (date._seconds && date._nanoseconds) {
      dateObj = new Date(date._seconds * 1000 + date._nanoseconds / 1000000);
    }
    // Handle string dates
    else if (typeof date === 'string') {
      dateObj = new Date(date);
    }
    // Handle Date objects
    else if (date instanceof Date) {
      dateObj = date;
    }
    // Handle timestamp em segundos
    else if (typeof date === 'number') {
      dateObj = new Date(date * 1000);
    } else {
      return 'N/A';
    }

    // Verificar se a data é válida
    if (isNaN(dateObj.getTime())) {
      return 'N/A';
    }

    return dateObj.toLocaleDateString('pt-BR');
  } catch (error) {
    console.error('Error formatting date:', error, date);
    return 'N/A';
  }
};


